var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "basket-list-item py-3" }, [
    _c(
      "div",
      { staticClass: "basket-item component-loading with-icon d-flex" },
      [
        _c("div", { staticClass: "image-container" }, [
          _c(
            "a",
            { attrs: { href: _vm._f("itemURL")(_vm.wishListItem) } },
            [
              _vm.image
                ? _c("lazy-img", {
                    attrs: {
                      "image-url": _vm.image,
                      alt: _vm._f("itemName")(_vm.wishListItem),
                      title: _vm._f("itemName")(_vm.wishListItem),
                      "picture-class": "d-block mw-100 mh-100",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "meta-container-wrapper" }, [
          _c("div", { staticClass: "meta-container-wrapper-inner mb-2" }, [
            _c("div", { staticClass: "meta-container" }, [
              _c("div", { staticClass: "position-relative w-100" }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "item-name text-primary text-appearance small font-weight-bold text-break",
                    attrs: { href: _vm._f("itemURL")(_vm.wishListItem) },
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm._f("itemName")(_vm.wishListItem)) +
                        "\n                        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "item-base-price small" }, [
                  _vm._v(
                    "\n                            " +
                      _vm._s(_vm._f("currency")(_vm.unitPrice)) +
                      "\n                        "
                  ),
                ]),
                _vm._v(" "),
                !(
                  _vm.wishListItem.unit.unitOfMeasurement === "C62" &&
                  _vm.wishListItem.unit.content === 1
                ) && _vm.wishListItem.variation.mayShowUnitPrice
                  ? _c(
                      "div",
                      { staticClass: "item-small-prices text-muted small" },
                      [
                        _c("div", [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.basePrice) +
                              "\n                            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.wishListContent"
                                )
                              ) + ": "
                            ),
                          ]),
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.wishListItem.unit.content) +
                              " " +
                              _vm._s(_vm.wishListItem.unit.names.name) +
                              "\n                            "
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "item-small-prices small" },
                  _vm._l(
                    _vm.wishListItem.attributes,
                    function (attribute, index) {
                      return _c("div", { key: index }, [
                        _c("strong", [
                          _vm._v(_vm._s(attribute.attribute.names.name) + ": "),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(attribute.value.names.name)),
                        ]),
                      ])
                    }
                  ),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "item-small-prices text-muted small" },
                  [
                    _vm._l(
                      _vm.wishListItem.variationProperties,
                      function (propertyGroup) {
                        return _vm._l(
                          propertyGroup.properties,
                          function (property, index) {
                            return _c("div", { key: index }, [
                              property.id !== 62
                                ? _c("div", [
                                    propertyGroup.name
                                      ? _c("strong", [
                                          _vm._v(
                                            _vm._s(propertyGroup.name) + ": "
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(property.names.name)),
                                    ]),
                                    _vm._v(" "),
                                    property.cast === "file"
                                      ? _c("span", [
                                          _c("a", {
                                            attrs: {
                                              href: _vm._f("propertyFileUrl")(
                                                property.values.value
                                              ),
                                              target: "_blank",
                                            },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                property.values.value
                                              ),
                                            },
                                          }),
                                        ])
                                      : _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              property.values.value
                                            ),
                                          },
                                        }),
                                  ])
                                : _vm._e(),
                            ])
                          }
                        )
                      }
                    ),
                  ],
                  2
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basket-item-container-right" }, [
              _c(
                "div",
                { staticClass: "qty-box-container ml-3" },
                [
                  _c("quantity-input", {
                    attrs: {
                      value: _vm.wishListItem.variation.intervalOrderQuantity,
                      min: _vm.wishListItem.variation.minimumOrderQuantity,
                      max: _vm.wishListItem.variation.maximumOrderQuantity,
                      timeout: 0,
                      interval:
                        _vm.wishListItem.variation.intervalOrderQuantity,
                      "variation-id": _vm.wishListItem.variation.id,
                    },
                    on: {
                      "quantity-change": function ($event) {
                        _vm.quantity = $event
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "price-box text-right my-1 ml-2" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "item-total-price font-weight-bold text-nowrap",
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm._f("currency")(_vm.quantity * _vm.unitPrice)
                        ) +
                        "\n                        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn btn-sm text-danger p-0",
                    attrs: { "data-testing": "remove-wlist-item" },
                    on: {
                      click: function ($event) {
                        return _vm.removeItem()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.$translate("Ceres::Template.wishListDelete")
                        ) +
                        "\n                            "
                    ),
                    _c("i", {
                      directives: [
                        {
                          name: "waiting-animation-infinite",
                          rawName: "v-waiting-animation-infinite",
                        },
                      ],
                      staticClass: "fa fa-trash-o default-float",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c("add-to-basket", {
                attrs: {
                  "variation-id": _vm.wishListItem.variation.id,
                  "is-salable":
                    !!_vm.wishListItem.filter &&
                    _vm.wishListItem.filter.isSalable,
                  "has-children":
                    !!_vm.wishListItem.filter &&
                    _vm.wishListItem.filter.hasActiveChildren,
                  "interval-quantity":
                    _vm.wishListItem.variation.intervalOrderQuantity || 1,
                  "minimum-quantity":
                    _vm.wishListItem.variation.minimumOrderQuantity,
                  "maximum-quantity":
                    !!_vm.wishListItem.variation.maximumOrderQuantity &&
                    _vm.wishListItem.variation.maximumOrderQuantity > 0
                      ? _vm.wishListItem.variation.maximumOrderQuantity
                      : null,
                  "order-properties": _vm.wishListItem.properties.filter(
                    (prop) => prop.property.isOderProperty
                  ),
                  "has-order-properties": _vm.wishListItem.hasOrderProperties,
                  "has-required-order-property":
                    _vm.wishListItem.hasRequiredOrderProperty,
                  "use-large-scale": false,
                  "show-quantity": false,
                  "item-url": _vm._f("itemURL")(_vm.wishListItem),
                  "has-price": _vm._f("hasItemDefaultPrice")(_vm.wishListItem),
                  "is-wish-list": true,
                  "prop-quantity": _vm.quantity,
                  "item-type": _vm.wishListItem.item.itemType,
                  "variation-properties": _vm.wishListItem.variationProperties,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "item-additional-information-container" }, [
            _c(
              "div",
              { staticClass: "item-additional-information" },
              [
                _vm.isDataFieldVisible("wishListItem.item.id")
                  ? [
                      _c("div", { staticClass: "mt-3" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$translate("Ceres::Template.wishListItemId")
                            ) + ":"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.wishListItem.item.id))]),
                      ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.isDataFieldVisible("wishListItem.variation.number")
                  ? [
                      _vm.wishListItem.variation.number
                        ? _c("div", [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.wishListItemNumber"
                                  )
                                ) + ":"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.wishListItem.variation.number)),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.wishListItem.variation.availability.names.name
                  ? _c("div", [
                      _c("span", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.wishListAvailability"
                              )
                            ) +
                            ":\n                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          class:
                            "single__availability availability_" +
                            _vm.wishListItem.variation.availability.names
                              .availabilityId,
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.wishListItem.variation.availability.names.name
                            )
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isDataFieldVisible("wishListItem.texts.description")
                  ? [
                      _vm.wishListItem.texts.description
                        ? _c("p", {
                            staticClass: "my-3",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.wishListItem.texts.description
                              ),
                            },
                          })
                        : _vm._e(),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.isDataFieldVisible("wishListItem.texts.shortDescription")
                  ? [
                      _vm.wishListItem.texts.shortDescription
                        ? _c("p", {
                            staticClass: "my-3",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.wishListItem.texts.shortDescription
                              ),
                            },
                          })
                        : _vm._e(),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }